import MeetingRoomScene from "@/models/MeetingRoomScene";

export const ZORO002MeetingRoom = new MeetingRoomScene({
    background: require('@/assets/images/scenes/zoro002/meeting/teammeeting_bg_c2.png'),
    foreground: require('@/assets/images/scenes/zoro002/meeting/teammeeting_table_c2.png')
});